// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './store'
import './pages'
import VueAwesomeSwiper from 'vue-awesome-swiper'

import 'swiper/dist/css/swiper.css'

Vue.config.productionTip = false

Vue.prototype.env = process.env.NODE_ENV
Vue.http = Vue.prototype.$http = axios
console.log("process.env", process.env.NODE_ENV)

// http response 拦截器
axios.interceptors.response.use(
  response => {
    // console.log(response)
    return response;
  },
  error => {
    console.log(error)
    return Promise.reject(error.response && error.response.data)   // 返回接口返回的错误信息
  });


Vue.use(VueAwesomeSwiper)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js